export enum Breakpoints {
	medium = 600,
	large = 1024,
	extraLarge = 1920,
}
